import React, { FunctionComponent } from "react"
import { Box, OutlinedInput } from "@material-ui/core"
import { InputLabel } from "../@citydna/common/InputLabel"
import {
  SchemaField,
  SchemaFieldSubVariant,
} from "../featuer-layer-settings/schema"
import { getHtmlInputType } from "./fieldHelpers"
import { useFormContext } from "react-hook-form"

interface DNATextFieldProps {
  field: SchemaField
}

export const TextField: FunctionComponent<DNATextFieldProps> = ({ field }) => {
  /** Hook up to the form */
  const { register, errors } = useFormContext()
  const error = errors[field.name || ""]

  return (
    <Box>
      <InputLabel htmlFor={field.name}>
        {field.alias}
        {!field.required && " (optional)"}
      </InputLabel>
      <OutlinedInput
        id={field.alias}
        name={field.name}
        multiline={field.variant === ("multiline" as SchemaFieldSubVariant)}
        fullWidth
        rows={4}
        color="secondary"
        type={getHtmlInputType(field.type)}
        inputRef={register({
          required: { value: field.required as boolean, message: "Value is required" },
          maxLength: { value: field.length as number, message: "Value is too long" },
        })}
        error={Boolean(error)}
      />
    </Box>
  )
}
